import numbro from 'numbro';

export const flattenQueryState = (queryState, defaultSort = [], defaultFilter = []) => {
    const params = {};

    if (!queryState) {
        return params;
    }

    let sortState = defaultSort;
    let filterState = defaultFilter;

    if (queryState.sortState.length) {
        sortState = queryState.sortState;
    }

    if (queryState.filterState.length) {
        filterState = queryState.filterState;
    }

    const sortPriority = sortState
        .filter((st) => st.sortPriority != null)
        .map((st) => st.sortPriority);
    const sortPriorityDefault = sortState.length ? [1] : null;

    params['SC'] = sortState.map((st) => st.sortColumn);
    params['SD'] = sortState.map((st) => st.sortDirection);
    params['SP'] = sortPriority.length ? sortPriority : sortPriorityDefault;
    // TODO since formatFilterType throws possible errors we should use a try catch and handle that race condition
    if (filterState) {
        // use filter display value if we have it
        params['FD'] = queryState.filterState.map((st) => st.filterDisplay)

        params['FC'] = queryState.filterState.map((st) => st.filterColumn);
        params['FT'] = queryState.filterState.map((st) =>
            formatFilterType(st.filterType)
        );
        params['FV'] = queryState.filterState.map((st) =>
            st.numAbbriv ? numbro(st.filterValue?.toLowerCase())._value :
            formatFilterValue(
                st.filterType,
                st.filterValueActual || st.filterValue
            )
        );
    }

    return params;
};

export const hasQueryStateChanged = (
    oldFlattenQueryState,
    newFlattenQueryState
) => {
    return !(
        arraysEqual(oldFlattenQueryState.FC, newFlattenQueryState.FC) &&
        arraysEqual(oldFlattenQueryState.FT, newFlattenQueryState.FT) &&
        arraysEqual(oldFlattenQueryState.FV, newFlattenQueryState.FV) &&
        arraysEqual(oldFlattenQueryState.SC, newFlattenQueryState.SC) &&
        arraysEqual(oldFlattenQueryState.SD, newFlattenQueryState.SD) &&
        arraysEqual(oldFlattenQueryState.SP, newFlattenQueryState.SP)
    );
};

export const arraysEqual = (array1, array2) => {
    if (!array1 && !array2) {
        return true;
    }
    if (!array1 || !array2) {
        return false;
    }

    return (
        array1.length === array2.length &&
        array1.every((value, index) => value === array2[index])
    );
};

export const formatFilterType = (type) => {
    if (!type) {
        throw new Error('No filter type to format')
    }
    // type can be passed with various casing. Normalize to lower to match map key casing.
    const normalizedType = type.toLowerCase();
    const typeMap = {
        'date range': 'dt_range',
        'date-time range': 'dt_range',
        equals: 'eq',
        'greater than': 'gt',
        includes: 'complex_text',
        'less than': 'lt',
        range: 'range',
        'starts with': 'complex_start',
        'text contains': 'complex_text',
        contains: 'complex_text',
        'word match': 'complex_word',
        empty: 'empty',
    };
    // assign to avoid repeat map lookup on the happy path.
    const typeString = typeMap[normalizedType];

    if (typeString) return typeString;

    throw new Error(`No type mapped for '${type}'`);
};

export const formatFilterValue = (filterType, filterValue) => {
    switch (filterType.toLowerCase()) {
        case 'date range':
            const vals = filterValue.split('|');
            const first = vals[0].includes('T')
                ? vals[0].split('T')[0]
                : vals[0];
            const second = vals[1].includes('T')
                ? vals[1].split('T')[0]
                : vals[1];
            return first + '~' + second;
        case 'date-time range': {
            const vals = filterValue.split('|');
            return vals[0] + '~' + vals[1]
        }
        case 'includes':
        case 'range':
            return filterValue.replace('|', '~');
        default:
            return filterValue;
    }
};
